<template>
  <v-layout>
    <v-flex>
      <v-icon
        @click="
          $router.push(
            `/result/${userData.id || userData.idUser}/${
              participant.idParticipant
            }`
          )
        "
        v-if="participant.resolved"
        class="mr-2"
        >mdi-printer</v-icon
      >
      <!-- <v-icon class="mr-2">mdi-printer</v-icon> -->
      <v-icon @click="dialog = true" class="mr-2">mdi-pencil-outline</v-icon>
      <v-icon @click="dialogDelete = true" class="mr-2">mdi-close</v-icon>
      <v-icon
        v-if="email && !participant.emailSended"
        @click="sendEmailPersonalURL"
        class="mr-2"
        >mdi-email</v-icon
      >
      <v-icon v-else-if="!email" @click="copyPersonalURL" class="mr-2"
        >mdi-link</v-icon
      >
    </v-flex>

    <!-- Ventana para editar cliente -->
    <v-dialog v-model="dialog" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Editar empleado</v-card-title
        >

        <v-form ref="form" @submit.prevent="send">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="name"
                      label="Nombre"
                      :rules="requiredRule"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="position"
                      label="Puesto"
                      :rules="requiredRule"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch
                      v-model="showEmailField"
                      label="Correo Electrónico"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-if="showEmailField"
                      v-model="email"
                      label="Correo Electrónico"
                      :rules="emailRule"
                      type="email"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">cancelar</v-btn>
            <v-btn color="primary" text type="submit">Actualizar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Ventana para eliminar -->
    <v-dialog v-model="dialogDelete" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Eliminar empleado</v-card-title
        >

        <v-card-text class="title"
          >¿Estás seguro de eliminar a este empleado?</v-card-text
        >

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false"
            >cancelar</v-btn
          >
          <v-btn color="primary" text @click="deleteParticipant"
            >Eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  props: {
    participant: Object,
    active: Boolean,
  },
  watch: {
    active(val) {
      //this.active = val
      return val;
    },
    showEmailField(value) {
      if (!value) {
        this.email = "";
      }
    },
  },
  data() {
    return {
      requiredRule: [(v) => !!v || "Este campo es obligatorio"],
      emailRule: [
        (v) => !!v || "Este campo es obligatorio",
        (v) => /.+@.+\..+/.test(v) || "El correo debe ser valido",
      ],
      //active : null,
      snackbar: false,
      message: "",
      work: this.participant.work,
      name: this.participant.name,
      email: this.participant.email,
      position: this.participant.position,
      dialog: false,
      dialogDelete: false,
      value: 0,
      host: process.env.VUE_APP_HOST,
      showEmailField: this.participant.email ? true : false,
    };
  },
  computed: {
    ...mapState(["userData"]),
  },
  methods: {
    sendEmailPersonalURL() {
      var personalURL = `http://guiats.human-express.com/#/questionnaire/${
        this.userData.id || this.userData.idUser
      }/login/${this.participant.work}/${this.participant.password}`;

      var data = {
        personalURL,

        idParticipant: this.participant.idParticipant,
        work: this.participant.work,
        email: this.participant.email,
        position: this.participant.position,
        clientName: this.userData.orgName,
        clientEmail: this.userData.email,
        participantName: this.participant.name,
        password: this.participant.password,
        phone: this.userData.phone,
      };

      axios
        .post(
          this.host + "/participants/sendPersonalURL.php",
          this.createFormData(data)
        )
        .then((response) => {
          this.dialog = false;
          this.message = response.data.message;
          this.snackbar = true;
          this.$emit("update", { message: response.data.message });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    copyPersonalURL() {
      this.copyText(
        `http://guiats.human-express.com/#/questionnaire/${
          this.userData.id || this.userData.idUser
        }/login/${this.participant.work}/${this.participant.password}`,
        "Enlace de acceso personal copiado al portapapeles"
      );
    },
    copyText(textToCopy, textToShow) {
      var aux = document.createElement("input");

      aux.setAttribute("value", textToCopy);

      document.body.appendChild(aux);

      aux.select();

      document.execCommand("copy");

      document.body.removeChild(aux);

      this.message = textToShow;
      this.snackbar = true;
    },
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          idParticipant: this.participant.idParticipant,
          work: this.work,
          name: this.name,
          position: this.position,
          email: this.email,
          idUser: sessionStorage.getItem("authorization"),
        };

        axios
          .post(
            this.host + "/participants/update.php",
            this.createFormData(data)
          )
          .then((response) => {
            this.dialog = false;
            this.$emit("update");
            this.message = response.data.message;
            this.snackbar = true;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    deleteParticipant() {
      let data = {
        idParticipant: this.participant.idParticipant,
        idUser: sessionStorage.getItem("authorization"),
      };
      axios
        .post(this.host + "/participants/delete.php", this.createFormData(data))
        .then((response) => {
          this.dialogDelete = false;
          this.message = response.data.message;
          this.snackbar = true;
          setTimeout(() => {
            this.$emit("update");
          }, 300);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    test() {
      this.message = "prueba";
      this.snackbar = true;
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    },
    setValue(value) {
      this.value = value;
    },
  },
  created() {
    this.$parent.$on("update", this.setValue);
  },
};
</script>